import { render, staticRenderFns } from "./rBingli.vue?vue&type=template&id=0c219fd6&scoped=true&"
import script from "./rBingli.vue?vue&type=script&lang=js&"
export * from "./rBingli.vue?vue&type=script&lang=js&"
import style0 from "./rBingli.vue?vue&type=style&index=0&id=0c219fd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c219fd6",
  null
  
)

export default component.exports